import React, { useState, useEffect } from "react";
import { Segment, Form, Input, Checkbox } from "semantic-ui-react";

const DataOrigin = ({
  dataSourceProp,
  updateDataSource,
  schemaStructureProp,
  uploadFile
}) => {
  const [schemaStructure, setSchemaStructure] = useState([]);
  const [schemaProperties, setSchemaProperties] = useState({});
  const [schemaAditionalProperties, setSchemaAditionalProperties] = useState(
    []
  );

  useEffect(() => {
    if (!schemaStructureProp) return;
    if (schemaStructureProp.properties) {
      let keysStructure = [];
      let keysSchemaAditionalProperties = [];

      for (const key in schemaStructureProp.properties) {
        if (
          schemaStructureProp.properties.hasOwnProperty.call(
            schemaStructureProp.properties,
            key
          )
        ) {
          const propertie = schemaStructureProp.properties[key];
          if (propertie.type === "object") {
            // sub level input extra data
            keysStructure.push(key);
            for (const subKey in propertie.properties) {
              if (
                propertie.properties.hasOwnProperty.call(
                  propertie.properties,
                  subKey
                )
              ) {
                const subPropertie = propertie.properties[subKey];
                subPropertie.name = subKey;
                keysSchemaAditionalProperties.push(subPropertie);
              }
            }
          } else if (propertie.order) keysStructure[propertie.order - 1] = key;
        }
      }

      setSchemaStructure(keysStructure);
      setSchemaProperties(schemaStructureProp.properties);
      setSchemaAditionalProperties(keysSchemaAditionalProperties);
    }
  }, [schemaStructureProp]);

  return (
    <Segment attached="bottom">
      <Form>
        {schemaStructure.map(field =>
          schemaProperties[field].type === "string" ? (
            <Form.Field
              key={field}
              control={Input}
              name={field}
              value={dataSourceProp[field] || ""}
              label={schemaProperties[field].label}
              placeholder={schemaProperties[field].label}
              onChange={updateDataSource}
            />
          ) : schemaProperties[field].type === "boolean" ? (
            schemaProperties[field].type1 === "binary" ? (
              <span key={field}>
                <strong>{schemaProperties[field].label}</strong>
                <input
                  type="file"
                  name={field}
                  labale={schemaProperties[field].label}
                  accept="text/plain, .csv"
                  onChange={uploadFile}
                />
              </span>
            ) : (
              <Form.Field
                key={field}
                control={Checkbox}
                name={field}
                checked={dataSourceProp[field] || false}
                label={schemaProperties[field].label}
                onChange={updateDataSource}
              />
            )
          ) : schemaProperties[field].type === "number" ? (
            <Form.Field
              control={Input}
              type="number"
              key={field}
              name={field}
              value={dataSourceProp[field] || ""}
              min={schemaProperties[field].minimum}
              label={schemaProperties[field].label}
              placeholder={schemaProperties[field].label}
              onChange={updateDataSource}
            />
          ) : schemaProperties[field].type === "object" ? (
            schemaAditionalProperties.map(aditionalField =>
              aditionalField.type === "string" ? (
                <Form.Field
                  key={aditionalField.label}
                  control={Input}
                  data-aditional-prop={true}
                  name={aditionalField.name}
                  value={
                    dataSourceProp["additionalParameter"]
                      ? dataSourceProp["additionalParameter"][
                          aditionalField.name
                        ]
                      : "" || ""
                  }
                  label={aditionalField.label}
                  placeholder={aditionalField.label}
                  onChange={updateDataSource}
                />
              ) : null
            )
          ) : null
        )}
      </Form>
    </Segment>
  );
};

DataOrigin.defaultProps = {
  dataSourceProp: {}
};

export default DataOrigin;
